import React, { useState } from "react";

function PlaysetsRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How does your swing set removal process work?",
      content: `
  Schedule a Free On-Site Estimate at a time that works for you—we offer same-day and next-day service. Our pricing is based on the size of your swing set and the time required for dismantling. Our expert team handles all the heavy lifting, safely dismantling and removing your swing set with efficiency. Whenever possible, we prioritize eco-friendly disposal by donating or recycling materials.
      `,
    },
    {
      title: "Do you offer eco-friendly disposal?",
      content: `
      Yes! We work with recycling centers and local charities to repurpose usable materials and dispose of the rest responsibly.
      `,
    },
    {
      title: "What areas do you serve?",
      content: `
       We proudly provide local swing set removal services in the Metro area and surrounding locations, including:

             Campbell,Los Altos,Fremont,Palo Alto,Saratoga,East Palo Alto,Cupertino,Los Gatos,Mountain View,San Jose,Milpitas,Newark,Santa Clara,Sunnyvale

      `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default PlaysetsRemovalFAQs;
